import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd ,ActivatedRoute } from '@angular/router';
import { Helpers } from '../helpers';
import { ScriptLoaderService } from '../_services/script-loader.service';

declare let mApp: any;
declare let mUtil: any;
declare let mLayout: any;
@Component({
selector: "theme-blank",
templateUrl: "./theme-blank.component.html",
encapsulation: ViewEncapsulation.None,
})
export class ThemeBlankComponent implements OnInit {

	

constructor(private _script: ScriptLoaderService, private _router: Router, private activatedRoute: ActivatedRoute)  {

}
ngAfterViewInit() {
}
ngOnInit()  {

}

}


// WEBPACK FOOTER //
// ./src/app/theme/theme-blank.component.ts